import { useState } from 'react';

export function Field({ label, hint, error, icon, required, children, valid }) {
  return (
    <label className="col gap-2" style={{ width: '100%' }}>
      {label && (
        <span className="mono" style={{
          fontSize: 11, letterSpacing: '0.16em', textTransform: 'uppercase',
          color: error ? 'var(--danger)' : 'var(--fg-muted)', display: 'flex', alignItems: 'center', gap: 6,
        }}>
          {label}
          {required && <span style={{ color: 'var(--accent)' }}>*</span>}
          {valid && <span style={{ color: 'var(--ok)', marginLeft: 'auto' }}>✓</span>}
        </span>
      )}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {icon && (
          <span style={{ position: 'absolute', left: 14, color: 'var(--fg-muted)', display: 'flex', pointerEvents: 'none' }}>
            {icon}
          </span>
        )}
        {children}
      </div>
      {(hint || error) && (
        <span style={{ fontSize: 12, color: error ? 'var(--danger)' : 'var(--fg-faint)' }}>
          {error || hint}
        </span>
      )}
    </label>
  );
}

export function Input({ icon, error, style, ...props }) {
  const [foc, setFoc] = useState(false);
  return (
    <input
      {...props}
      onFocus={e => { setFoc(true); props.onFocus && props.onFocus(e); }}
      onBlur={e => { setFoc(false); props.onBlur && props.onBlur(e); }}
      style={{
        width: '100%', height: 52, padding: icon ? '0 16px 0 42px' : '0 16px',
        background: 'var(--surface)', color: 'var(--fg)', fontFamily: 'var(--font-body)', fontSize: 15,
        border: `1px solid ${error ? 'var(--danger)' : foc ? 'var(--accent)' : 'var(--line-strong)'}`,
        borderRadius: 'var(--r-md)', outline: 'none',
        boxShadow: foc ? '0 0 0 3px rgba(225,18,23,0.14)' : 'none',
        transition: 'border .18s, box-shadow .18s', ...style,
      }}
    />
  );
}
